import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { getUrlWithMedium, navigateTo } from "./utils/utils";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { useBrandUrl } from "@/hooks";
import { useLastSearch } from "@/hooks/useLastSearch";
import { useDefaultBackToSearch } from "@/contexts/classified";
import { HttpStatus } from "@/constants";
import { LastSearchButton } from "./LastSearchButton";
const getBtnText = (status) => {
    return status === HttpStatus.UNPUBLISHED
        ? "errorpage.unpublished.cta.label"
        : "errorpage.deleted.cta.label";
};
export const LastSearch = ({ status }) => {
    const { t } = useI18n();
    const { bWindow } = useBrowserAPI();
    const lastSearch = useLastSearch();
    const baseUrl = useBrandUrl();
    const isProject = useIsNewBuildProject();
    const searchPath = isProject ? "/project-search?" : "/classified-search?";
    const defaultBackToSearch = useDefaultBackToSearch();
    const [displayLastSearchButton, setDisplayLastSearchButton] = useState(false);
    const buildBackLink = () => {
        const defaultBackToSearchUrl = defaultBackToSearch
            ? `${baseUrl}${searchPath}${defaultBackToSearch}`
            : baseUrl;
        return lastSearch && typeof lastSearch !== "boolean"
            ? getUrlWithMedium(lastSearch.link, "" // Need tracking medium
            )
            : defaultBackToSearchUrl;
    };
    const link = buildBackLink();
    const redirectToHomePage = () => {
        navigateTo(baseUrl, bWindow);
    };
    const btnText = getBtnText(status);
    useEffect(() => {
        if (typeof lastSearch !== "boolean" || defaultBackToSearch) {
            setDisplayLastSearchButton(true);
        }
    }, [lastSearch, defaultBackToSearch]);
    const formatCriteria = (criteria) => {
        var _a;
        if (!(criteria === null || criteria === void 0 ? void 0 : criteria.distributionType) ||
            !(criteria === null || criteria === void 0 ? void 0 : criteria.estateType) ||
            !((_a = criteria === null || criteria === void 0 ? void 0 : criteria.locations) === null || _a === void 0 ? void 0 : _a.label))
            return [];
        const formattedCriteria = [];
        const { distributionType, estateType, locations, minRooms, minBedrooms, maxPrice, minSpace, } = criteria;
        if (distributionType) {
            formattedCriteria.push(t(`errorpage.restart_search.criteria.${distributionType.toLowerCase()}`));
        }
        if (estateType) {
            formattedCriteria.push(estateType);
        }
        if (locations) {
            formattedCriteria.push(typeof locations === "string" ? locations : locations.label);
        }
        if (minRooms) {
            formattedCriteria.push(t("errorpage.restart_search.criteria.rooms").replace("{rooms}", minRooms === null || minRooms === void 0 ? void 0 : minRooms.toString()));
        }
        if (minBedrooms) {
            formattedCriteria.push(t("errorpage.restart_search.criteria.bedrooms").replace("{bedrooms}", minBedrooms === null || minBedrooms === void 0 ? void 0 : minBedrooms.toString()));
        }
        if (minSpace) {
            formattedCriteria.push(t("errorpage.restart_search.criteria.space").replace("{space}", minSpace === null || minSpace === void 0 ? void 0 : minSpace.toString()));
        }
        if (maxPrice) {
            formattedCriteria.push(t("errorpage.restart_search.criteria.price").replace("{price}", maxPrice === null || maxPrice === void 0 ? void 0 : maxPrice.toString()));
        }
        return formattedCriteria;
    };
    const criteria = lastSearch && typeof lastSearch !== "boolean" && lastSearch.criteria
        ? formatCriteria(lastSearch.criteria)
        : [];
    const shouldDisplayCriteria = criteria.length !== 0;
    return (_jsxs(_Fragment, { children: [_jsx(Box, { display: "flex", typography: "typography.headline.22.bold", paddingBottom: "spacing.4", textAlign: {
                    "breakpoint.base": "center",
                    "breakpoint.lg": "left",
                }, children: t("errorpage.restart.search.title") }), lastSearch !== undefined && !lastSearch && !defaultBackToSearch ? (_jsx(Box, { display: "flex", paddingTop: "spacing.24", maxWidth: {
                    "breakpoint.base": "unset",
                    "breakpoint.lg": "312px",
                }, width: "100%", children: _jsx(Button, { isFullWidth: true, onPress: redirectToHomePage, children: t(btnText) }) })) : (displayLastSearchButton && (_jsx(LastSearchButton, { lastSearch: lastSearch, shouldDisplayCriteria: shouldDisplayCriteria, criteria: criteria, link: link, redirectToHomePage: redirectToHomePage })))] }));
};
